import { useTimingMetricStorage, useConfigurationStorage } from '@data';
import { AttributeValue, captureTimingMetric } from '@utils-global';

export const useTimingMetric = () => {
  const { startTimer, removeTimer, getStartTime } = useTimingMetricStorage();
  const { configuration } = useConfigurationStorage();

  const startTimingMetric = (key: string) => {
    startTimer(key);
  };

  const stopTimingMetric = (key: string, metadata?: Record<string, AttributeValue>) => {
    const startTime = getStartTime(key);
    if (startTime === undefined) {
      console.error(`Timer ${key} has not been started`);
      return;
    }

    const duration = performance.now() - startTime;
    removeTimer(key);

    captureTimingMetric(key, duration, configuration?.data, metadata);
  };

  return { startTimingMetric, stopTimingMetric };
};
